import React from "react";
import { getProfilePhoto } from "../../../utilities/aiMatchmaker";

const useMatchPhoto = (match) => {
  const [photo, setPhoto] = React.useState(null);
  const userId = match && match.otherId;
  const hasPhoto = !!(match && match.hasPhoto);

  React.useEffect(() => {
    let cancelled = false;
    if (!userId || !hasPhoto) {
      setPhoto(null);
      return;
    }
    (async () => {
      let res;
      try {
        res = await getProfilePhoto(userId);
      } catch (e) {
        res = null;
      }
      if (!cancelled && res && res.success && res.url) {
        setPhoto({
          url: res.url,
          focalX: res.photoFocalX ?? 50,
          focalY: res.photoFocalY ?? 30,
        });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [userId, hasPhoto]);

  return photo;
};

export default useMatchPhoto;
